export default "__VITE_ASSET__BMBsL3yd__"